var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnschedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 0.75C4.75 0.334375 4.41563 0 4 0C3.58437 0 3.25 0.334375 3.25 0.75V2H2C0.896875 2 0 2.89688 0 4V4.5V6V14C0 15.1031 0.896875 16 2 16H12C13.1031 16 14 15.1031 14 14V6V4.5V4C14 2.89688 13.1031 2 12 2H10.75V0.75C10.75 0.334375 10.4156 0 10 0C9.58437 0 9.25 0.334375 9.25 0.75V2H4.75V0.75ZM1.5 6H12.5V14C12.5 14.275 12.275 14.5 12 14.5H2C1.725 14.5 1.5 14.275 1.5 14V6ZM8 12.5C8 12.2348 7.89464 11.9804 7.70711 11.7929C7.51957 11.6054 7.26522 11.5 7 11.5C6.73478 11.5 6.48043 11.6054 6.29289 11.7929C6.10536 11.9804 6 12.2348 6 12.5C6 12.7652 6.10536 13.0196 6.29289 13.2071C6.48043 13.3946 6.73478 13.5 7 13.5C7.26522 13.5 7.51957 13.3946 7.70711 13.2071C7.89464 13.0196 8 12.7652 8 12.5ZM7.75 7.75C7.75 7.33437 7.41563 7 7 7C6.58437 7 6.25 7.33437 6.25 7.75V9.75C6.25 10.1656 6.58437 10.5 7 10.5C7.41563 10.5 7.75 10.1656 7.75 9.75V7.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnschedule);
export default __webpack_public_path__ + "static/media/unschedule.d7393dec04267dea2fc92d793b83aa4a.svg";
export { ForwardRef as ReactComponent };